<template>
    <div class="tuceList hml_whplt">
        <div class="back" @click="backClick">
            <img src="@/assets/svg/details/back_white.svg" alt="">
        </div>
        <swiperList :style="{padding: '1rem .3rem 0'}">
            <ul class="listBox">
                <li
                v-for="(item,index) in imgArray"
                :key="index"
                @click="imgSlideClick(index)"
                >
                    <img :src="item" alt="">
                </li>
            </ul>
        </swiperList>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
export default {
    data() {
        return {
            imgArray: []
        }
    },
    created(){
        let currentData = this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].list[this.levelThreeIndex];
        let imgArray = currentData.images.replace(/\n/g,"").split("<br />");
        imgArray.forEach((item,index) => {
            if(item.length > 10 && item.indexOf("gps") == -1){
                if(item.split("|")[2]){
                    this.getImgSrc(item.split("|")[2],1).forEach((value,ind) => {
                        this.imgArray.push(value);
                    });
                }
                
            }
        });
        console.log(this.imgArray);
    },
    methods: {
        backClick(){
            this.$router.push("/panorama");
        },
        imgSlideClick(index){
            this.setTuceIndex(index);
            this.$router.push("/tuce");
        },
        ...publicData.mapMutations(["setTuceIndex"])
    },
    computed: {
        ...publicData.mapState(["firstLevelIndex","allData","secondLevelIndex","levelThreeIndex"])
    },
}
</script>

<style lang="scss" scoped>
.tuceList{
    background: #000;
    .listBox{
        display: flex;
        flex-flow: wrap;
    }
    li{
        width: 1.6rem;
        height: 1.6rem;
        margin-right: .15rem;
        margin-bottom: .16rem;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
            height: 100%;
            width: auto;
        }
        &:nth-of-type(4n+4){
            margin-right: 0;
        }
    }
    .back{
        width: .24rem;
        height: .4rem;
        position: absolute;
        left: 0;
        top: 0;
        -webkit-box-sizing: content-box;
        box-sizing: content-box;
        padding: .3rem;
        z-index: 10;
        img{
            transform: rotate(180deg);
        }
    }
}
</style>